export default __webpack_public_path__ + "static/media/title-winners_th@2x.8ec6a9bc.png";